import { render, staticRenderFns } from "./SyncCost.vue?vue&type=template&id=b5b572b6&scoped=true"
import script from "./SyncCost.vue?vue&type=script&lang=js"
export * from "./SyncCost.vue?vue&type=script&lang=js"
import style0 from "./SyncCost.vue?vue&type=style&index=0&id=b5b572b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b572b6",
  null
  
)

export default component.exports